export default __webpack_public_path__ + "static/media/witnesses-3.71dc8bbf.jpg";